import { jwtDecode } from "jwt-decode";
import { useEffect } from "react";
import { removeLoginSession } from "../utils/common";

export const useSetPermission = (setPermission) => {
    const token = localStorage.getItem("token");

    useEffect(() => {
        try {
            if (!token) return;
            const { access, tabPanel } = jwtDecode(token);
            // Build key → access entry map from the JWT for checkButtonAccess
            const keyToAccess = Object.values(access).reduce((acc, entry) => {
                if (entry.key) acc[entry.key] = entry;
                return acc;
            }, {});
            setPermission({ access, tabPanel, keyToAccess });
        } catch (error) {
            if (window.location.pathname !== "/") {
                removeLoginSession();
                window.location.href = "/";
            }
            console.log(error);
        }
    }, [token]);
};
